import V2Empty from '@/common/components/Data/V2Empty';
import V2LogRecord from '@/common/components/SpecialBusiness/V2LogRecord';
import { isArray, isNotEmptyAny } from '@lhb/func';
import { Button, Spin } from 'antd';
import { FC, forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react';
import HistoryModal from './HistoryModal';
import styles from '../index.module.less';
import { useMethods } from '@lhb/hook';
import V2InfiniteScrollList from '@/common/components/Data/V2InfiniteScrollList';
import { getHistoryRecordPage } from '@/common/api/expandStore/expansiontask';

const scrollableTarget = 'expandStoreHistoryScrollList';

/**
 * @Description 操作历史
 */
const History:FC<{id, ref?}> = forwardRef(({ id }, ref) => {
  const [detail, setDetail] = useState<any>({
    visible: false,
    content: null
  });
  const [totalNum, setTotalNum] = useState<number>(0);
  const pageRef = useRef<any>(1);
  const [data, setData] = useState<any>([]);
  const [loading, setLoading] = useState<boolean>(false);

  useImperativeHandle(ref, () => ({
    refresh: methods.reload
  }));

  useEffect(() => {
    methods.reload();
  }, []);

  const methods = useMethods({
    reload() {
      pageRef.current = 1;
      setData([]);
      setTotalNum(0);
      methods.loadData();
    },
    loadData() {
      if (loading) return;

      const params = {
        page: pageRef.current,
        size: 20,
        moduleType: 'STANDARD_TASK',
        moduleId: id,
      };

      setLoading(true);
      getHistoryRecordPage(params).then((res) => {
        const { objectList, totalNum } = res || {};

        setTotalNum(totalNum);
        if (isArray(objectList)) {
          const list = objectList?.map((item) => {
            const timeArr = item?.createdAt.split(' ');
            return {
              date: timeArr?.[0],
              status: 'finish',
              children: [
                {
                  name: `${item.userName} ${item.category}`,
                  time: timeArr?.[1],
                  description: item.description,
                  titleExtra: <Button type='link' style={{ padding: 0, color: '#006AFF' }} onClick={() => { setDetail({ visible: true, content: item.content }); }}>查看</Button>
                }
              ]
            };
          });
          setData([...data, ...list]);
          pageRef.current = pageRef.current + 1;
        }
      }).finally(() => {
        setLoading(false);
      });
    },
  });

  return (
    <div className={styles.history} id={scrollableTarget}>
      {isNotEmptyAny(data)
        ? <V2InfiniteScrollList
          hasMore={data.length < totalNum}
          loadData={methods.loadData}
          loader={<Spin/>}
          dataLength={data.length}
          scrollableTargetId={scrollableTarget}
          endMessage=''
        >
          <V2LogRecord items={data} type={2}/>
        </V2InfiniteScrollList>
        : !loading && <V2Empty centerInBlock customTip='暂无历史记录'/>}
      <HistoryModal detail={detail} setDetail={setDetail}/>
    </div>
  );
});

export default History;
